<template>
  <div>
    <h1>403 Доступ запрещен</h1>
  </div>
</template>